module.exports = __webpack_public_path__ + "static/media/team-2.de26a134.jpg";